import * as actionTypes from './actionTypes';
import { axiosProtected, axiosPublic } from '../../axios-wizard';
import { normalize } from 'normalizr';
import * as schema from '../schema';
import i18n from "i18next";
import { authLogout } from './auth';


export const newPasswordRequest = (data) => {
    const url = '/api/new_password_request'

    const pw_data = {
      email: data['email']
    }

    return dispatch => {
        dispatch( newPasswordRequestStart() );
        return axiosPublic.post( url, pw_data )
            .then( response => {
               const normalizedUsers = normalize(response.data, { users: schema.arrayOfUsers  })
               dispatch(newPasswordRequestSuccess(normalizedUsers));
            } )
            .catch( error => {
                dispatch(newPasswordRequestFailed());
                return error.response.data;
            } );
    };
};

export const newPasswordRequestStart = () => {
    return {
        type: actionTypes.RECREATE_PASSWORD_START
    };
};

export const newPasswordRequestSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.RECREATE_PASSWORD_START,
        values: normalizedUsers
    };
};

export const newPasswordRequestFailed = () => {
    return {
        type: actionTypes.RECREATE_PASSWORD_START
    };
};



export const getProfile = (state) => {
  if (state.inventory !== undefined && state.inventory.users !== undefined) {
    const x = Object.values(state.inventory.users).filter(x => x.id === localStorage.getItem("userId"));
    return (Array.isArray(x))? x[0] : undefined;
  } else {
    return [];
  }
}


export const createAccount = (data) => {
    const url = '/api/register'

    const profile = {
      first_name: data['firstName'],
      last_name: data['lastName'],
      company: data['company'],
      branch: data['branch'],
      position: data['position'],
      street: data['street'],
      zipcode: data['zipcode'],
      city: data['city'],
      countrycode: data['country'],
      phone: data['phone'],
      email: data['email'],
      contact_type: data['contactType'],
      password: data['password'],
      locale: i18n.language.toUpperCase(),
    }

    return dispatch => {
        dispatch( createAccountStart() );
        return axiosPublic.post( url, {register: profile} )
            .then( response => {
               const normalizedUsers = normalize(response.data, { users: schema.arrayOfUsers  })
               dispatch(createAccountSuccess(normalizedUsers));
            } )
            .catch( error => {
                dispatch(createAccountFailed());
                return error.response;
            } );
    };
};

export const createAccountStart = () => {
    return {
        type: actionTypes.CREATE_ACCOUNT_START
    };
};

export const createAccountSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.CREATE_ACCOUNT_SUCCESS,
        values: normalizedUsers
    };
};

export const createAccountFailed = () => {
    return {
        type: actionTypes.CREATE_ACCOUNT_FAILED
    };
};



export const saveProfile = (data) => {
    const url = '/api/account/profile'

    const profile = {
      first_name: data['firstName'],
      last_name: data['lastName'],
      company: data['company'],
      branch: data['branch'],
      position: data['position'],
      street: data['street'],
      zipcode: data['zipcode'],
      city: data['city'],
      countrycode: data['country'],
      contact_type: data['contactType'],
      phone: data['phone'],
    }

    return dispatch => {
        dispatch( saveProfileStart() );
        return axiosProtected.put( url, {profile: profile} )
            .then( response => {
               const normalizedUsers = normalize(response.data, { users: schema.arrayOfUsers  })
               dispatch(saveProfileSuccess(normalizedUsers));
            } )
            .catch( error => {
                dispatch(saveProfileFailed());
            } );
    };
};

export const saveProfileStart = () => {
    return {
        type: actionTypes.SAVE_PROFILE_START
    };
};

export const saveProfileSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.SAVE_PROFILE_SUCCESS,
        values: normalizedUsers
    };
};

export const saveProfileFailed = () => {
    return {
        type: actionTypes.SAVE_PROFILE_FAILED
    };
};




export const saveSettings = (data) => {
    const url = '/api/account/settings'

    const settings = {
      locale: data['locale'],
    }

    return dispatch => {
        dispatch( saveSettingsStart() );
        return axiosProtected.put( url, {settings: settings} )
            .then( response => {
               const normalizedUsers = normalize(response.data, { users: schema.arrayOfUsers  })
               dispatch(saveSettingsSuccess(normalizedUsers));
            } )
            .catch( error => {
                dispatch(saveSettingsFailed());
            } );
    };
};

export const saveSettingsStart = () => {
    return {
        type: actionTypes.SAVE_SETTINGS_START
    };
};

export const saveSettingsSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.SAVE_SETTINGS_SUCCESS,
        values: normalizedUsers
    };
};

export const saveSettingsFailed = () => {
    return {
        type: actionTypes.SAVE_SETTINGS_FAILED
    };
};




export const savePassword = (data) => {
    const url = '/api/account/password'

    const pwData = {
      password: data['password'],
      old_password: data['oldPassword'],
      password_confirmation: data['passwordConfirmation'],
    }

    return dispatch => {
        dispatch( savePasswordStart() );
        return axiosProtected.put( url, pwData )
            .then( response => {
               dispatch(savePasswordSuccess());
               return true
            } )
            .catch( error => {
                dispatch(savePasswordFailed());
                return error.response.data;
            } );
    };
};

export const savePasswordStart = () => {
    return {
        type: actionTypes.SAVE_PASSWORD_START
    };
};

export const savePasswordSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.SAVE_PASSWORD_SUCCESS
    };
};

export const savePasswordFailed = () => {
    return {
        type: actionTypes.SAVE_PASSWORD_FAILED
    };
};


export const deleteAccount = (data) => {
    const url = '/api/account/delete'

    const pwData = {
      password: data['oldPassword'],
    }

    return dispatch => {
        dispatch( deleteAccountStart() );
        return axiosProtected.put( url, pwData )
            .then( response => {
               dispatch(authLogout());
            } )
            .catch( error => {
                dispatch(deleteAccountFailed());
                return error.response.data;
            } );
    };
};

export const deleteAccountStart = () => {
    return {
        type: actionTypes.SAVE_PASSWORD_START
    };
};

export const deleteAccountSuccess = ( normalizedUsers ) => {
    return {
        type: actionTypes.DELETE_ACCOUNT_SUCCESS
    };
};

export const deleteAccountFailed = () => {
    return {
        type: actionTypes.DELETE_ACCOUNT_FAILED
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/account.js